import { createActionsHook, createHook, createStore, type StoreActionApi } from 'react-sweet-state';

import type { HubElementPlaceholderExtensionsState } from './types';

const initialState: HubElementPlaceholderExtensionsState = {
	hubElementPlaceholderLocalId: null,
	hubElementPlaceholderPreviewComponent: null,
};

// Actions for managing the Custom Site Extensions state that is shared between the extension and the config panel
const actions = {
	setPreviewContentForHubElementPlaceholder:
		(extensionLocalId: string | null, previewComponent: React.ReactNode | null) =>
		({ setState }: StoreActionApi<HubElementPlaceholderExtensionsState>) => {
			setState({
				hubElementPlaceholderLocalId: extensionLocalId,
				hubElementPlaceholderPreviewComponent: previewComponent,
			});
		},
};

const HubElementPlaceholderExtensionsStore = createStore({
	initialState,
	actions,
	name: 'HubElementPlaceholderExtensionsStore',
});

export const useHubElementPlaceholderExtensions = createHook(HubElementPlaceholderExtensionsStore);
export const useHubElementPlaceholderExtensionsActions = createActionsHook(
	HubElementPlaceholderExtensionsStore,
);
